import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { MessageCircle, Upload } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-atomic-black py-12 md:py-16" data-id="element-267">
      {/* Background hero image */}
      <div className="absolute inset-0 z-0" data-id="element-268">
        <img src="https://cdn.magicpatterns.com/uploads/7eSsupoXc8181n79WwMtbD/Home-hero1.jpg" alt="Custom printed apparel stacked on work table ready for shipping" className="absolute inset-0 w-full h-full object-cover" data-id="element-269" />
        <div className="absolute inset-0 bg-gradient-to-r from-atomic-black via-atomic-black/85 to-atomic-black/70" data-id="element-270" />
        <div className="absolute inset-0 bg-gradient-to-t from-atomic-black via-atomic-black/50 to-transparent" data-id="element-271" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-272">
        <div className="max-w-4xl mx-auto text-center" data-id="element-273">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 text-atomic-green text-sm font-medium mb-6 backdrop-blur-sm" data-id="element-274">
            <span className="w-2 h-2 rounded-full bg-atomic-green animate-pulse" data-id="element-275" />
            <span data-id="element-276">Next-Day DTF Shipping · No Minimums</span>
          </motion.div>

          {/* Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 leading-tight" data-id="element-277">
            DTF Transfers +{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-atomic-green to-lime-400" data-id="element-278">
              Screen Printing
            </span>
          </motion.h1>

          {/* Sub-line */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-279">
            Fast, reliable custom printing for businesses, teams, and
            organizations. Text us to get started — most customers get a
            response within minutes.
          </motion.p>

          {/* 3 CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-6" data-id="element-280">
            {/* 1. Text Us - Primary */}
            <a href="sms:+15174149232" className="w-full sm:w-auto" data-id="element-281">
              <Button size="lg" className="w-full sm:w-auto group gap-2" data-id="element-282">
                <MessageCircle className="w-5 h-5" data-id="element-283" />
                Text Us
              </Button>
            </a>

            {/* 2. Facebook Message - Secondary */}
            <a href="https://m.me/atomicMI" target="_blank" rel="noopener noreferrer" title="Facebook Message" aria-label="Facebook Message" className="w-full sm:w-auto" data-id="element-284">
              <Button variant="outline" size="lg" className="w-full sm:w-auto gap-2" data-id="element-285">
                <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden="true" data-id="element-286">
                  <path d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.2 5.42 3.15 7.2V22l2.95-1.62c.84.23 1.72.36 2.65.36h.25c5.64 0 9.75-4.13 9.75-9.66C20.75 6.13 17.64 2 12 2zm1.08 13.02l-2.5-2.67-4.87 2.67 5.36-5.69 2.56 2.67 4.81-2.67-5.36 5.69z" data-id="element-287" />
                </svg>
                Facebook Message
              </Button>
            </a>

            {/* 3. Upload DTF Files */}
            <a href="/dtf-printing#builder" className="w-full sm:w-auto" data-id="element-288">
              <Button variant="ghost" size="lg" className="w-full sm:w-auto gap-2" data-id="element-289">
                <Upload className="w-5 h-5" data-id="element-290" />
                Upload DTF Files
              </Button>
            </a>
          </motion.div>

          {/* Trust Line */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="text-sm text-gray-500 max-w-2xl mx-auto" data-id="element-291">
            Michigan shop · nationwide shipping
          </motion.p>
        </div>
      </div>
    </section>;
}